import {Component, EventEmitter, Input, Output} from '@angular/core';

/**
 * Generated class for the EditInputComponent component.
 */
@Component({
  selector: 'edit-input',
  templateUrl: 'edit-input.html',
  styleUrls: ['./edit-input.scss']
})
export class EditInputComponent {

  isApp = (!document.URL.startsWith('http') || document.URL.indexOf('http://localhost/') !== -1);
  isBrowser = !this.isApp;

  @Input()
  isEdit = false;

  @Input()
  type = 'text';

  @Input()
  modelData: any;

  @Input()
  placeholder?: any = '';

  @Input()
  options?: any;

  @Input()
  hasButton = false;

  @Output()
  textFieldButtonClick = new EventEmitter();

  @Output()
  modelDataOut = new EventEmitter();

  constructor() {

  }

  modelChanged(data) {
    this.modelDataOut.emit(data);
  }

  buttonClick(event) {
    this.textFieldButtonClick.emit(event);
  }

}
